/* eslint-disable arrow-body-style */
/* eslint-disable no-return-await */
import axios from 'axios';
import utils from './utils';

const API_ADMIN = `${utils.svcUrl()}course`;

export default {
  createCourse: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  updateCourse: (id, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/edit/${id}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getCourses: (userId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_ADMIN}/getall/creator/${userId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getPromo: (courseId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_ADMIN}/get/promotion/${courseId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  addPromo: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/add/promotion`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  deletePromo: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/delete/promotion`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getNotifications: (courseId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_ADMIN}/get/notification/${courseId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  cloneCourse: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/newCourse/fromExistingCourse`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  updateNotification: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/update/notification/${data.courseId}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getCourse: (courseId) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/${courseId}`, { url: 'https://example.com' })
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  deleteCourse: (courseId) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${API_ADMIN}/${courseId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
};
